import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { PageAttributeType } from "../../entity";
import { makeAttributePicker } from "./pickAttribute";
var makeAttributePagesLoader = function(loadAttributePageContent) {
    return function() {
        var _ref = _async_to_generator(function(slug, primaryAttribute) {
            var tryPickAttribute, cityDistrict, city, state, country, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        tryPickAttribute = makeAttributePicker(primaryAttribute);
                        cityDistrict = tryPickAttribute(PageAttributeType.CityDistrict);
                        city = tryPickAttribute(PageAttributeType.City, cityDistrict);
                        state = tryPickAttribute(PageAttributeType.State, city);
                        country = tryPickAttribute(PageAttributeType.Country, state);
                        _tmp = {
                            attributes: {
                                city: city,
                                cityDistrict: cityDistrict,
                                country: country,
                                state: state
                            }
                        };
                        return [
                            4,
                            Promise.all([
                                loadAttributePageContent(slug, primaryAttribute),
                                loadAttributePageContent(slug, cityDistrict),
                                loadAttributePageContent(slug, city),
                                loadAttributePageContent(slug, state),
                                loadAttributePageContent(slug, country)
                            ])
                        ];
                    case 1:
                        /**
     * For each of the ancestor attibutes located above, we'll try to load a
     * page but there may be none available or could be gone (i.e. status
     * 404/410).
     */ return [
                            2,
                            (_tmp.pages = _state.sent(), _tmp)
                        ];
                }
            });
        });
        return function(slug, primaryAttribute) {
            return _ref.apply(this, arguments);
        };
    }();
};
export { makeAttributePagesLoader };
